/*
 * @Descripttion:
 * @version:
 * @Author: susj
 * @Date: 2020-09-14 17:45:16
 * @LastEditors: susj
 * @LastEditTime: 2022-10-09 19:10:17
 */
export default {
  insertData: [
    {
      name: '方案信息',
      val: 'text',
    },
    {
      name: '平面图',
      val: 'plan',
    },
    {
      name: '效果图',
      val: 'effectPic',
    },
    {
      name: '全景图',
      val: 'panorama',
    },
    // {
    //   name: 'CAD图纸',
    //   val: 'cad',
    // },
    {
      name: '报价',
      val: 'quote',
    },
    {
      name: '空间名',
      val: 'roomName',
    },
    {
      name: '文案',
      val: 'sentence',
    },
  ],
  insertDataItem:
  {
    text: [{ name: '方案名称', val: 'schemeName' },
    { name: '客户姓名', val: 'customerName' },
    { name: '房型', val: 'roomType' },
    { name: '详细地址', val: 'address' },
    { name: '楼盘名', val: 'buildingName' },
    { name: '客户手机', val: 'customerMobile' },
    { name: '创建日期', val: 'createTime' },
    { name: '账号昵称', val: 'nickname' }],
    plan: [{ name: '全屋平面图', val: 'wholeHouse' }],
    effectPic: [],
    panorama: [],
    // cad: [],
    quote: [
      { name: '铝门窗表格', val: 'doorWindowsTable' },
      { name: '门窗', val: 'doorWindows', hide: true },
    ],
    roomName: [],
    sentence: [],
  },
  previewMockData: {
    customerName: '示例-张先生',
    schemeName: '示例-凤凰花苑B栋1201',
    roomType: '示例-3室2厅2卫1厨',
    address: '示例-广东省广州市天河区xx路凤凰花苑B栋1201',
    buildingName: '示例-凤凰花苑',
    customerMobile: '示例-1550000xxxx',
    nickname: '示例-光影如一',
    createTime: '示例-2022/10/09',
  },
};
